// extracted by mini-css-extract-plugin
export var dataCell = "_py-2";
export var dataRow = "_py-0";
export var headerRow = "_py-1";